module.exports = __webpack_public_path__ + "static/img/BU04PB.124bb6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU04PB.jpg
// module id = rAs2
// module chunks = 1